import { MetricConverter } from './helpers';

const CurrentUnits = ['A', 'kA', 'mA'] as const;
export type TCurrentUnit = (typeof CurrentUnits)[number];

class CurrentConverter extends MetricConverter<TCurrentUnit, 'A'> {
    baseUnit = 'A' as const;
    units = CurrentUnits;
}

export const currentConverter = new CurrentConverter();
